export interface Waypoint {
  type: WaypointType
  name?: string
  lat?: number
  lng?: number
}

export enum WaypointType {
  full,
  latLng,
  any,
  empty,
  serializedE,
  serializedS,
  myLocation,
}

export enum TransportMode {
  drive = 'drive',
  walk = 'walk',
  publicTransport = 'publicTransport',
  bicycle = 'bicycle',
  default = 'default',
}

export const includesSourceDestination = (waypoints: Waypoint[]): boolean => {
  return Boolean(
    waypoints.length > 1 &&
      waypoints[0].type !== WaypointType.empty &&
      waypoints[0].type !== WaypointType.any &&
      waypoints[waypoints.length - 1].type !== WaypointType.empty &&
      waypoints[waypoints.length - 1].type !== WaypointType.any
  )
}

export const includesMyLocation = (waypoints: Waypoint[]): boolean => {
  return Boolean(waypoints.find((waypoint) => waypoint.type === WaypointType.myLocation))
}

export const toSpliced = (
  waypoints: Waypoint[],
  start: number,
  deleteCount: number,
  ...items: Waypoint[]
): Waypoint[] => {
  return [...waypoints].splice(start, deleteCount, ...items)
}

export const filterOutEmpty = (waypoints: Waypoint[]): Waypoint[] => {
  return waypoints.filter(
    (waypoint) => waypoint.type !== WaypointType.empty && waypoint.type !== WaypointType.any
  )
}

export function getOrigin(waypoints: Waypoint[]): Waypoint {
  return waypoints.length > 0 ? waypoints[0] : { type: WaypointType.empty }
}

export function getDestination(waypoints: Waypoint[]): Waypoint {
  return waypoints.length > 1 ? waypoints[waypoints.length - 1] : { type: WaypointType.empty }
}

export const getIntermediate = (waypoints: Waypoint[]): Waypoint[] => {
  const intermediateWaypoints = waypoints.length < 3 ? [] : waypoints.slice(1).slice(0, -1)
  return filterOutEmpty(intermediateWaypoints)
}
